import { TableTemplate } from "components/templates/default/table/TableTemplate";
import Status, { StatusType } from "components/blocks/status/Status";
import { useLocation } from "react-router-dom";
import AddRule from "./add";
import EditRule from "./edit/EditRuleContainer";
import {
  AlertRuleListResponse,
  PostAlertRequest,
} from "api/interfaces/alertInterface.interface";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import * as mediaQuery from "components/MediaQuery";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";

type Props = {
  columns: TableColumnsType<AlertRuleListResponse>;
  data: Array<AlertRuleListResponse>;
  onModal: (type?: string) => void;
  isAddModal: boolean;
  isEditModal: boolean;
  isViewModal: boolean;
  status: StatusType;
  onRowClick: (row: AlertRuleListResponse) => void;
  onClickCreate: (alertInfo: PostAlertRequest) => void;
  onClickSearch: ClickSearch;
  onChangePage: (page: number, totalRows: number) => void;
  paginationTotalRows: number;
  paginationInfo: BasePagination;
  selectedRule: AlertRuleListResponse | undefined;
  selectedAccount: ProfileAccountInfo;
  isRowClickEditable: boolean;
  tablePending: boolean;
};

export function AlertRulePresenter(props: Props): JSX.Element {
  const location = useLocation();
  const centerChildren = <Status status={props.status} />;

  // const data = props.alertRules ? props.alertRules.result[0].ruleList : [];

  return (
    <>
      <TableTemplate
        onClickBtn={() => props.onModal("add")}
        buttonLabel="Add New Rule"
        onClickSearch={props.onClickSearch}
        centerChildren={centerChildren}
        requiredPermissions={"manageAlertRules"}
        // requiredPermissions={
        //   props.selectedAccount.accountLevel !== "EU" ? "" : "manageAlertRules"
        // }
        keyword={props.paginationInfo.keyword}
        data-testid="alert-rule-rule-table-template-modal"
      >
        <CommonTable
          columns={props.columns}
          dataSource={props.data}
          queryInfo={props.paginationInfo}
          onChangePage={props.onChangePage}
          loading={props.tablePending}
        />
      </TableTemplate>
      {props.isAddModal && (
        <AddRule isEdit={false} onModal={() => props.onModal("add")} />
      )}

      {props.isEditModal ? (
        <EditRule
          isEdit={props.isEditModal}
          alertRule={props.selectedRule}
          //isView={props.selectedAccount.accountLevel !== LEVEL_TYPE.EU}
          onModal={() => props.onModal("edit")}
        />
      ) : null}
    </>
  );
}
